import { t } from 'helpers/i18n';
import { IType } from './implement';
import { IssueTypeTypeOf } from './task';

const SHOP_STATUS: { [key: string]: any } = {
  HasntImplement: {
    id: 0,
    name: t('HasntImplement'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  NotActualAddress: {
    id: 1,
    name: t('NotActualAddress'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  StoppedBusiness: {
    id: 10,
    name: t('StoppedBusiness'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  NotPracticalShop: {
    id: 11,
    name: t('NotPracticalShop'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  NotFoundLocationShop: {
    id: 12,
    name: t('NotFoundLocationShop'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  HasImplement: {
    id: 3,
    name: t('HasImplement'),
    ticketType: [
      IssueTypeTypeOf.APPROACH,
      IssueTypeTypeOf.ASSIGN,
      IssueTypeTypeOf.POS365,
      IssueTypeTypeOf.SALE_MACHINE,
      IssueTypeTypeOf.SAPO,
    ],
  },
  Accept: {
    id: 5,
    name: t('AcceptPayment'),
    ticketType: [IssueTypeTypeOf.RENTING],
  },
  Refuse: {
    id: 6,
    name: t('RefusePayment'),
    ticketType: [IssueTypeTypeOf.RENTING],
  },
  DontSignContract: {
    id: 0,
    name: t('DontSignContract'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
  },
  SignedContract: {
    id: 1,
    name: t('SignedContract'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
  },
  SeeLater: {
    id: 2,
    name: t('SeeLater'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
  ReviewMore: {
    id: 3,
    name: t('ReviewMore'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
  AgreeDontSignContract: {
    id: 4,
    name: t('AgreeDontSignContract'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
  DontPickUpPhone: {
    id: 5,
    name: t('DontPickUpPhone'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
  CantContact: {
    id: 6,
    name: t('CantContact'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
  IncorrectPhoneNumber: {
    id: 7,
    name: t('IncorrectPhoneNumber'),
    ticketType: [IssueTypeTypeOf.ADD_PROFILE_MC],
    isShowTicketMCTrial: true,
  },
};

const SHOP_STATUS_TAKE_CARE: { [key: string]: any } = {
  BUSINESS_BREAK: {
    label: t('StopBusiness'),
    value: 2,
  },
  WORKING: {
    label: t('Working'),
    value: 7,
  },
  MOVED: {
    label: t('Moved'),
    value: 8,
  },
  WANT_LIQUIDATE: {
    label: t('WantLiquidate'),
    value: 9,
  },
};

enum issueType {
  MORE_REVIEW = 22,
  ACCEPT_AND_NOT_SIGNED = 23,
}

const POTENTIAL_TYPE = {
  POTENTIAL: 'potential',
  OFFICAL: 'official',
};

const MAX_IMAGE_SHOP = 20;
const MAX_IMAGE_LOGO = 1;
const URL_MAP_BASE = 'https://www.google.com/maps/place/';

const SERVICE: { [key: string]: { id: number; name: string; code: string } } = {
  QR: {
    id: 1,
    name: 'QR',
    code: 'QR',
  },
  CTT: {
    id: 2,
    name: 'CTT',
    code: 'CTT',
  },
  SPOS: {
    id: 3,
    name: 'SPOS',
    code: 'SPOS',
  },
  RENTING: {
    id: 4,
    name: 'RENTING',
    code: 'RENTING',
  },
  POS365: {
    id: 5,
    name: 'POS365',
    code: 'POS365',
  },
  SAPO: {
    id: 6,
    name: 'SAPO',
    code: 'SAPO',
  },
  SELLING_DEVICE: {
    id: 7,
    name: 'BÁN MÁY ',
    code: 'SELLING_DEVICE ',
  },
};

const SERVICE_NAB: {
  [key: string]: { id: number; name: string; code: string };
} = {
  SPOS: {
    id: 3,
    name: 'SPOS',
    code: 'SPOS',
  },
};

const STATUS_KPI: IType = {
  NotCompleted: {
    label: t('NewShopMobile.NotCompleted'),
    value: 0,
  },
  Completed: {
    label: t('NewShopMobile.Completed'),
    value: 1,
  },
  All: {
    label: t('All'),
    value: 2,
  },
};

export enum IShopStatus {
  ACTIVATED = 'Hoạt động',
  WAITING_FOR_APPROVE = 'Chờ duyệt',
  NEED_UPDATE_DOCUMENT = 'Bổ sung HS',
  POTENTIAL = 'Tiềm năng',
}

const STATUS_OF_MC_SHOP: {
  [key: string]: { text: string; code: number; color: string };
} = {
  [IShopStatus.ACTIVATED]: {
    text: 'Hoạt động',
    code: 1,
    color: '#1990FF',
  },
  [IShopStatus.WAITING_FOR_APPROVE]: {
    text: 'Chờ duyệt',
    code: 2,
    color: '#26a44d',
  },
  [IShopStatus.NEED_UPDATE_DOCUMENT]: {
    text: 'Bổ sung HS',
    code: 3,
    color: '#ca9de6',
  },
  [IShopStatus.POTENTIAL]: {
    text: 'Tiềm năng',
    code: 4,
    color: '#FFCC5C',
  },
};

const SHOP_STATUS_SPOS: {
  [key: string]: { value: number; name: string };
} = {
  CustomerReject: {
    value: 0,
    name: t('CustomerReject'),
  },
  SignedContract: {
    value: 1,
    name: t('SignedContract'),
  },
  SeeLater: {
    value: 2,
    name: t('SeeLater'),
  },
  ReviewMore: {
    value: 3,
    name: t('ReviewMore'),
  },
  DontPickUpPhone: {
    value: 4,
    name: t('DontPickUpPhone'),
  },
  CantContact: {
    value: 5,
    name: t('CantContact'),
  },
  IncorrectPhoneNumber: {
    value: 6,
    name: t('IncorrectPhoneNumber'),
  },
  AgreeDontSignContract: {
    value: 7,
    name: t('AgreeDontSignContract'),
  },
};

export default {
  SHOP_STATUS,
  issueType,
  POTENTIAL_TYPE,
  MAX_IMAGE_SHOP,
  MAX_IMAGE_LOGO,
  URL_MAP_BASE,
  SERVICE,
  STATUS_KPI,
  STATUS_OF_MC_SHOP,
  IShopStatus,
  SHOP_STATUS_TAKE_CARE,
  SHOP_STATUS_SPOS,
  SERVICE_NAB,
};
